import React, { useState, useEffect, useRef } from 'react';
import {
  TextInput,
  FormGroup,
  Modal,
  Loading,
  Form,
} from '@carbon/react';
import useForm from '@/lib/hooks/useForm';
import { useCreateContactMutation, useLazyGetContactQuery, useUpdateContactMutation } from '@/redux/new_services/contacts';

const ContactModalForm = ({id = "new", hideModal: onCloseForm }) => {

  const [updateMutation, { isLoading: isSaving }] = useUpdateContactMutation();
  const [createMutation, { isLoading: isCreating }] = useCreateContactMutation();

  const {item: contact, onChangeField, onSaveRequest, onCloseForm: closeFormFromUseForm, unsaved, loading} = useForm({
    id,
    getLazy: useLazyGetContactQuery,
    updateMutation,
    createMutation,
    defaultValues: {
      firstname: "",
      lastname: "",
      mail: "",
      phone_number: "",
    }
  });

  return (
    <Modal
      open={true}
      danger={false}
      size="lg"
      primaryButtonText={'Speichern'}
      secondaryButtonText={'Abrechen'}
      modalHeading="Kontakt hinzufügen/bearbeiten"
      onRequestClose={() => onCloseForm()}
      onRequestSubmit={() => { onSaveRequest((success) => { success && onCloseForm()}) }}
      hasScrollingContent
      aria-label="Kontakt Form">
      <Loading active={loading || isSaving || isCreating} withOverlay={true} />
      <Form>
        <FormGroup legendText="">
          <TextInput
            labelText="Vorname"
            value={contact.firstname}
            id="form_contact_firstname_name"
            autoComplete="off"
            invalid={contact.firstname.length < 2}
            invalidText={
              'Sie müssen dem Kontakt einen Namen geben'
            }
            onChange={(e) =>
              onChangeField('firstname', e.target.value)
            }
          />
          <TextInput
            labelText="Nachname"
            value={contact.lastname}
            id="form_contact_lastname"
            autoComplete="off"
            invalid={contact.lastname.length < 2}
            invalidText={
              'Sie müssen dem Kontakt einen Nachnamen geben'
            }
            onChange={(e) =>
              onChangeField('lastname', e.target.value)
            }
          />

          <TextInput
            labelText="Telefonnummer"
            value={contact.phone_number}
            id="form_contact_phone_number"
            autoComplete="off"
            onChange={(e) =>
              onChangeField('phone_number', e.target.value)
            }
          />
          <TextInput
            labelText="E-Mail"
            value={contact.mail}
            id="form_contact_mail"
            autoComplete="off"
            onChange={(e) =>
              onChangeField('mail', e.target.value)
            }
          />
        </FormGroup>
      </Form>
    </Modal>
  );
};

export default ContactModalForm;
